module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Alarm-clock-ff1aa710076a6120cd437b13a4952322.svg";